import type { Report as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

export type Report = {
  name: string;
  reportId: string;
};

export const fromGql = (item: GQLItem): Report => take<Report>(item, 'name', 'reportId');
